import * as React from "react";
import styled from "styled-components";
const RenderError = styled.div`
  white-space: break-spaces;
`;
const ReportRenderErrorPage = ({ error }) => /* @__PURE__ */ React.createElement(RenderError, { id: "render-error", "data-testid": "render-error" }, error.stack);
export default ReportRenderErrorPage;
